import { getSegmentGroup, SegmentGroup } from '@fxtr/i18n';
import { shouldShowTresorId } from './shouldShowTresorId';

/** @param {string | null | undefined} segment */
function isRenaultSegment(segment) {
  try {
    return Boolean(segment) && getSegmentGroup(segment) === SegmentGroup.RENAULT;
  } catch {
    return false;
  }
}

/**
 * Translation key for the business-name hint.
 * Motrio and Renault follow the selected garage segment. The invoice hint is
 * for a Fixter deployment; every other case uses the no-invoices hint.
 *
 * @param {string | null | undefined} segment
 * @param {boolean} isFixterDeployment
 * @returns {string}
 */
export function businessNameHelpKey(segment, isFixterDeployment) {
  if (shouldShowTresorId(segment)) {
    return 'maia.garageInfo.help.businessNameMotrioWebsite';
  }
  if (isRenaultSegment(segment)) {
    return 'maia.garageInfo.help.businessNameRenaultWebsite';
  }
  if (isFixterDeployment) {
    return 'maia.garageInfo.help.businessName';
  }
  return 'maia.garageInfo.help.businessNameNoInvoices';
}
